module.exports = __webpack_public_path__ + "img/file_pdf.aa98f1b7.svg";